export function startStarfield(canvas) {
  if (!canvas) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ctx = canvas.getContext('2d');
  const stars = [];
  function resize() {
    canvas.width = window.innerWidth * devicePixelRatio;
    canvas.height = window.innerHeight * devicePixelRatio;
    canvas.style.width = '100%';
    canvas.style.height = '100%';
  }
  resize();
  window.addEventListener('resize', resize);
  const count = reduce ? 40 : 120;
  for (let i = 0; i < count; i += 1) {
    stars.push({
      x: Math.random(),
      y: Math.random(),
      z: 0.3 + Math.random() * 0.7,
      p: Math.random(),
    });
  }
  let raf;
  function tick() {
    const { width, height } = canvas;
    ctx.clearRect(0, 0, width, height);
    for (const s of stars) {
      if (!reduce) s.p = (s.p + 0.002 * s.z) % 1;
      const alpha = 0.25 + s.z * 0.6;
      ctx.fillStyle = `rgba(23, 179, 191, ${alpha})`;
      ctx.beginPath();
      ctx.arc(s.x * width, s.y * height, s.z * 1.6 * devicePixelRatio, 0, Math.PI * 2);
      ctx.fill();
    }
    if (!reduce) raf = requestAnimationFrame(tick);
  }
  tick();
  return () => cancelAnimationFrame(raf);
}
